import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema} from './config';


const EditInventoryPricing = ({dialog = false}) => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  return (
    <EditForm title={"Inventory Pricing"} initialValues={initialValues} fields={formFields} schema={schema} url={`inventory_pricing`}  dialog={dialog} redirect={`/settings/inventory/pricing`}>
      
     </EditForm>
  );
}

export default EditInventoryPricing;